import { Calendar } from 'lucide-react';

import type { ExtractedDate } from '@/api/client';
import { Badge } from './badge';

interface AudienciaBadgeProps {
  datas: ExtractedDate[] | null | undefined;
  className?: string;
}

/**
 * Badge indicando a data de audiência ou sessão de julgamento mais próxima
 * extraída de uma comunicação.
 *
 * Filtra apenas datas com tipo de comparecimento; seleciona a futura mais
 * próxima (ou a mais recente se todas forem passadas).
 */
export function AudienciaBadge({ datas, className }: AudienciaBadgeProps) {
  if (!datas || datas.length === 0) return null;

  const audiencias = datas.filter(d => d.tipo === 'audiencia' || d.tipo === 'sessao');
  if (audiencias.length === 0) return null;

  // Ordenar por data e pegar a mais próxima
  const sorted = [...audiencias].sort((a, b) => a.data.localeCompare(b.data));
  const today = new Date().toISOString().slice(0, 10);
  const proxima = sorted.find(d => d.data >= today) ?? sorted[sorted.length - 1];

  const dateObj = new Date(proxima.data + 'T12:00:00');
  const isCurrentYear = dateObj.getFullYear() === new Date().getFullYear();
  const formatted = dateObj.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    ...(isCurrentYear ? {} : { year: 'numeric' }),
  });
  const hora = proxima.hora ? ` ${proxima.hora}` : '';

  return (
    <Badge variant="outline" className={`text-[11px] shrink-0 gap-1 text-muted-foreground ${className ?? ''}`}>
      <Calendar className="h-3 w-3" />
      {formatted}{hora}
    </Badge>
  );
}
